import * as React from 'react';
import Cookies from '../containers/Cookies';

export default (props) => (<Cookies {...props} />);
